import axios from "axios";
import { getTokens } from "../services/auth";

export const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

function withAuthorizationHeader(options) {
  const { access } = getTokens();

  if (!access) {
    return options;
  }

  return {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${access}`,
    },
  };
}

function request(url, config = {}) {
  const { withToken, ...baseConfig } = config;
  let options = baseConfig;
  if (withToken) {
    options = withAuthorizationHeader(options);
  }
  return instance(url, options);
}

export const Axios = {
  get: (url, config) => request(url, { withToken: true, ...config, method: "GET" }),
  delete: (url, config) => request(url, { withToken: true, ...config, method: "DELETE" }),
  post: (url, data, config) => request(url, { withToken: true, ...config, data, method: "POST" }),
  put: (url, data, config) => request(url, { withToken: true, ...config, data, method: "PUT" }),
  patch: (url, data, config) => request(url, { withToken: true, ...config, data, method: "PATCH" }),
};
